import { z } from 'zod';

export const playerStatValueSchema = z
	.object({
		id: z.union([z.number(), z.string()]).optional(),
		title: z.string().optional(),
		value: z.union([z.number(), z.string()]).optional(),
	})
	.passthrough();

export const playerMatchStatsPlayerSchema = z
	.object({
		id: z.union([z.number(), z.string()]).optional(),
		playerName: z.string().optional(),
		stats: z.array(playerStatValueSchema).optional(),
	})
	.passthrough();

export const playerMatchStatsTeamSchema = z
	.object({
		players: z.array(playerMatchStatsPlayerSchema).optional(),
	})
	.passthrough();

export const playerMatchStatsSchema = z
	.object({
		homeTeam: playerMatchStatsTeamSchema.optional(),
		awayTeam: playerMatchStatsTeamSchema.optional(),
	})
	.passthrough();

export type PlayerStatValue = z.infer<typeof playerStatValueSchema>;
export type PlayerMatchStatsPlayer = z.infer<
	typeof playerMatchStatsPlayerSchema
>;
export type PlayerMatchStatsTeam = z.infer<typeof playerMatchStatsTeamSchema>;
export type PlayerMatchStats = z.infer<typeof playerMatchStatsSchema>;
